import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {setupStore} from "./Redux/store";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./Infrastructure/provider/AuthProvider";
import {GlobalVariablesProvider} from "./Infrastructure/provider/GlobalVariablesProvider";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const store = setupStore()

root.render(
    <BrowserRouter>
        <GlobalVariablesProvider>
            <Provider store={store}>
                <App/>
            </Provider>
        </GlobalVariablesProvider>

    </BrowserRouter>
);


reportWebVitals();
